export function addZIfMissing(str) {
    if (!str) {
        return null;
    }
    return str.endsWith("Z") ? str : str + "Z";
  }